// extracted by mini-css-extract-plugin
module.exports = {"successPageWrapper":"successPage_successPageWrapper__2czEE","content":"successPage_content__13fK2"};